// Landing page ("/") — Karrierehuset-voiced copy. nb is the primary language;
// en mirrors it for the language switcher.
export const homeTranslations = {
  en: {
    eyebrow: 'Karrierehuset Kompetanseportal',
    heroTitle: 'A clearer picture of the road ahead',
    heroSub: 'Digital competence mapping that gives our career advisors a richer foundation — and you a report you can act on.',
    doors: {
      advisorTitle: 'I am an advisor',
      advisorBody: 'Log in to create assessments, follow your candidates and approve reports.',
      advisorCta: 'Log in',
      advisorDashboard: 'Go to my dashboard',
      advisorRegister: 'New advisor? Register with your invitation code.',
      candidateTitle: 'I am a candidate',
      candidateBody: 'You don’t need an account. Your advisor sends you a personal link — open it to start your assessment, at your own pace.',
      candidateHint: 'Can’t find your link? Contact your advisor.',
    },
    how: {
      title: 'How it works',
      steps: [
        { title: 'Your advisor sets it up', body: 'The assessment is tailored to you — which tests, which topics, and your CV as the starting point.' },
        { title: 'You answer at your own pace', body: 'A personal link, no login. Scenarios, short tests and a conversation with an AI interviewer.' },
        { title: 'The AI drafts a report', body: 'Tests, interview and CV are brought together into one draft — competencies, personality and career paths.' },
        { title: 'Your advisor signs off', body: 'Nothing is final until a human has reviewed, adjusted and approved the report with you.' },
      ],
      trust: 'The report is always a draft until your advisor has approved it. Analysed by AI — signed by people.',
    },
    measures: {
      title: 'What the assessment covers',
      items: [
        { title: 'Situational judgement', body: 'How you weigh real workplace situations — no right-or-wrong trick questions.' },
        { title: 'Cognitive aptitude', body: 'Reasoning and information processing, kept short and focused.' },
        { title: 'Personality', body: 'Jungian type (MBTI) — and your Persolog DISC profile when your advisor includes it.' },
        { title: 'AI interview', body: 'A calm, in-depth conversation about motivation, values and what matters in your next role.' },
      ],
    },
    bottomCta: 'Ready to get started?',
    bottomCtaButton: 'Log in as advisor',
  },
  nb: {
    eyebrow: 'Karrierehuset Kompetanseportal',
    heroTitle: 'Et tydeligere bilde av veien videre',
    heroSub: 'Digital kompetansekartlegging som gir karriereveilederne våre et rikere grunnlag — og deg en rapport det går an å handle på.',
    doors: {
      advisorTitle: 'Jeg er rådgiver',
      advisorBody: 'Logg inn for å opprette kartlegginger, følge kandidatene dine og godkjenne rapporter.',
      advisorCta: 'Logg inn',
      advisorDashboard: 'Gå til min oversikt',
      advisorRegister: 'Ny rådgiver? Registrer deg med invitasjonskode.',
      candidateTitle: 'Jeg er kandidat',
      candidateBody: 'Du trenger ingen konto. Rådgiveren din sender deg en personlig lenke — åpne den for å starte kartleggingen, i ditt eget tempo.',
      candidateHint: 'Finner du ikke lenken? Ta kontakt med rådgiveren din.',
    },
    how: {
      title: 'Slik fungerer det',
      steps: [
        { title: 'Rådgiveren legger til rette', body: 'Kartleggingen tilpasses deg — hvilke tester, hvilke temaer, og CV-en din som utgangspunkt.' },
        { title: 'Du svarer i ditt eget tempo', body: 'En personlig lenke, ingen innlogging. Scenarier, korte tester og en samtale med en AI-intervjuer.' },
        { title: 'AI-en lager et utkast', body: 'Tester, intervju og CV sammenstilles til ett utkast — kompetanser, personlighet og karriereveier.' },
        { title: 'Rådgiveren kvalitetssikrer', body: 'Ingenting er endelig før et menneske har gjennomgått, justert og godkjent rapporten sammen med deg.' },
      ],
      trust: 'Rapporten er alltid et utkast til rådgiveren din har godkjent den. Analysert av AI — signert av mennesker.',
    },
    measures: {
      title: 'Hva kartleggingen dekker',
      items: [
        { title: 'Situasjonsvurdering', body: 'Hvordan du veier reelle arbeidssituasjoner — ingen lurespørsmål med fasit.' },
        { title: 'Kognitive evner', body: 'Resonnering og informasjonsbehandling — kort og konsentrert.' },
        { title: 'Personlighet', body: 'Jungiansk type (MBTI) — og Persolog DISC-profilen din når rådgiveren inkluderer den.' },
        { title: 'AI-intervju', body: 'En rolig dybdesamtale om motivasjon, verdier og hva som er viktig i neste jobb.' },
      ],
    },
    bottomCta: 'Klar til å komme i gang?',
    bottomCtaButton: 'Logg inn som rådgiver',
  },
};
